import { createContext } from "react";

type ToggleMfaStepContextType = {
  mfaStepEnabled: boolean;
  toggleMfaStep: () => void;
};

const ToggleMfaStepContext = createContext<ToggleMfaStepContextType>({
  mfaStepEnabled: false,
  toggleMfaStep: () => undefined,
});

export default ToggleMfaStepContext;
